import { defineMessages } from "./define";

export const commonMessages = defineMessages({
  ru: {
    "common.page_error_title": "Не удалось открыть страницу",
    "common.page_error_description": "Обновите страницу. Если ошибка повторяется, попробуйте позже.",
    "common.module_error_description": "Не удалось загрузить файлы страницы. Проверьте подключение к интернету и обновите страницу.",
    "common.reload_page": "Обновить страницу",
    "common.loading": "Загрузка",
    "common.loading_page": "Загружаем страницу",
    "common.loading_nfts": "Загрузка NFT",
    "common.load_failed": "Не удалось загрузить данные",
    "common.retry": "Повторить",
    "common.close": "Закрыть",
    "common.media_unavailable": "Изображение недоступно",
    "common.media_unavailable_alt": "{alt}: изображение недоступно",
    "common.brand_home": "{name} — главная",
    "common.support_contact": "Написать в поддержку",
    "common.restoring_session": "Восстанавливаем сессию",
    "common.checking_session": "Проверяем сессию",
    "common.language": "Язык",

    "common.footer_nav": "Информация",
    "common.footer_terms": "Условия использования",
    "common.footer_privacy": "Конфиденциальность",
    "common.footer_support": "Поддержка",

    "common.cookie_region": "Использование cookie",
    "common.cookie_text": "Мы используем cookie и локальное хранилище для авторизации, языка и оформления сайта. Кнопка «Понятно» закрывает это уведомление.",
    "common.cookie_more": "Подробнее",
    "common.cookie_ok": "Понятно",

    "common.not_found_title": "Страница не найдена",
    "common.not_found_desc": "Проверьте адрес или выберите доступный раздел.",
    "common.not_found_market": "В маркет",
    "common.not_found_home": "На главную",
    "common.not_found_owns": "Мои NFT",
    "common.not_found_login": "Войти",

    "common.validation_email_required": "Укажите email.",
    "common.validation_email_invalid": "Введите корректный email.",
    "common.validation_password_length": "Пароль должен содержать от 6 до 20 символов.",
    "common.validation_password_upper": "Добавьте хотя бы одну заглавную букву.",
    "common.validation_password_lower": "Добавьте хотя бы одну строчную букву.",
    "common.validation_password_digit": "Добавьте хотя бы одну цифру.",
    "common.validation_password_special": "Добавьте специальный символ: ! @ # $ % ^ & *.",
    "common.validation_invite_invalid": "Введите корректный код приглашения.",

    "common.error_invalid_email": "Проверьте адрес электронной почты.",
    "common.error_invalid_password": "Проверьте пароль.",
    "common.error_unknown_user": "Пользователь с такими данными не найден.",
    "common.error_exists_email": "Этот адрес электронной почты уже зарегистрирован.",
    "common.error_invalid_invite_code": "Промокод не найден.",
    "common.error_not_have_money": "На балансе недостаточно средств.",
    "common.error_already_owned": "Этот NFT уже принадлежит вам.",
    "common.error_already_saled": "NFT уже выставлен на продажу.",
    "common.error_is_sold": "NFT уже продан.",
    "common.error_image_not_find": "NFT не найден.",
    "common.error_own_not_find": "NFT не найден среди ваших активов.",
    "common.error_u_cant_buy": "Покупки для аккаунта временно недоступны. Обратитесь в поддержку.",
    "common.error_u_cant_withdraw": "Вывод временно ограничен. Обратитесь в поддержку.",
    "common.error_invalid_amount": "Введите корректную сумму.",
    "common.error_invalid_method": "Выберите доступный метод.",
    "common.error_invalid_details": "Проверьте реквизиты.",
    "common.error_invalid_bank": "Проверьте выбранный банк.",
    "common.error_small_payment_amount": "Сумма меньше минимальной для этого способа.",
    "common.error_unavailable_method": "Этот способ временно недоступен. Выберите другой.",
    "common.error_currency_in_sale": "Нельзя сменить валюту, пока у вас есть NFT, выставленные на продажу. Снимите их с продажи и повторите попытку.",
    "common.error_invalid_code": "Неверный код подтверждения. Проверьте приложение и попробуйте снова.",
    "common.error_already_verified": "Email уже подтверждён.",
    "common.error_unverified": "Email ещё не подтверждён. Проверьте почту и перейдите по ссылке.",
    "common.error_unauthorized": "Сессия недействительна. Войдите снова.",
    "common.error_auction_not_found": "Аукцион не найден.",
    "common.error_auction_not_started": "Аукцион ещё не начался.",
    "common.error_auction_ended": "Аукцион уже завершён.",
    "common.error_bid_too_low": "Ставка ниже минимальной. Обновите страницу и повысьте ставку.",
    "common.error_buy_now_unavailable": "Выкуп сразу для этого лота недоступен.",
    "common.error_blocked_by_protection": "Запрос заблокирован защитой. Отключите прокси или VPN либо обратитесь в поддержку.",
    "common.error_service_unavailable": "Сервис временно недоступен. Попробуйте позже.",
    "common.error_invalid_api_response": "Сервер вернул данные в неподдерживаемом формате.",
    "common.error_timeout": "Сервер не ответил вовремя. Попробуйте ещё раз.",
    "common.error_network": "Не удалось связаться с сервером. Проверьте подключение к интернету.",
    "common.error_aborted": "Запрос отменён.",
    "common.error_rate_limited": "Слишком много запросов. Попробуйте позже.",
    "common.error_not_found": "Запрошенные данные не найдены.",
    "common.error_conflict": "Данные уже изменились. Обновите страницу и повторите действие.",
    "common.error_unprocessable": "Проверьте заполненные поля.",
    "common.error_request_failed": "Не удалось выполнить запрос. Попробуйте ещё раз.",
    "common.error_unexpected": "Произошла непредвиденная ошибка. Попробуйте ещё раз."
  },
  en: {
    "common.page_error_title": "Unable to open this page",
    "common.page_error_description": "Reload the page. If the problem persists, try again later.",
    "common.module_error_description": "The page files could not be loaded. Check your internet connection and reload the page.",
    "common.reload_page": "Reload page",
    "common.loading": "Loading",
    "common.loading_page": "Loading page",
    "common.loading_nfts": "Loading NFTs",
    "common.load_failed": "Couldn't load data",
    "common.retry": "Retry",
    "common.close": "Close",
    "common.media_unavailable": "Image unavailable",
    "common.media_unavailable_alt": "{alt}: image unavailable",
    "common.brand_home": "{name} — home",
    "common.support_contact": "Contact support",
    "common.restoring_session": "Restoring your session",
    "common.checking_session": "Checking your session",
    "common.language": "Language",

    "common.footer_nav": "Information",
    "common.footer_terms": "Terms of use",
    "common.footer_privacy": "Privacy",
    "common.footer_support": "Support",

    "common.cookie_region": "Cookie usage",
    "common.cookie_text": "We use cookies and local storage for sign-in, language and site appearance. The “Got it” button dismisses this notice.",
    "common.cookie_more": "Learn more",
    "common.cookie_ok": "Got it",

    "common.not_found_title": "Page not found",
    "common.not_found_desc": "Check the address or pick an available section.",
    "common.not_found_market": "To the market",
    "common.not_found_home": "To the home page",
    "common.not_found_owns": "My NFTs",
    "common.not_found_login": "Log in",

    "common.validation_email_required": "Enter your email.",
    "common.validation_email_invalid": "Enter a valid email.",
    "common.validation_password_length": "The password must be 6 to 20 characters long.",
    "common.validation_password_upper": "Add at least one uppercase letter.",
    "common.validation_password_lower": "Add at least one lowercase letter.",
    "common.validation_password_digit": "Add at least one digit.",
    "common.validation_password_special": "Add a special character: ! @ # $ % ^ & *.",
    "common.validation_invite_invalid": "Enter a valid invite code.",

    "common.error_invalid_email": "Check your email address.",
    "common.error_invalid_password": "Check your password.",
    "common.error_unknown_user": "No user found with these details.",
    "common.error_exists_email": "This email address is already registered.",
    "common.error_invalid_invite_code": "Promo code not found.",
    "common.error_not_have_money": "Insufficient balance.",
    "common.error_already_owned": "You already own this NFT.",
    "common.error_already_saled": "This NFT is already listed for sale.",
    "common.error_is_sold": "This NFT has already been sold.",
    "common.error_image_not_find": "NFT not found.",
    "common.error_own_not_find": "This NFT was not found among your assets.",
    "common.error_u_cant_buy": "Purchases are temporarily unavailable for this account. Please contact support.",
    "common.error_u_cant_withdraw": "Withdrawals are temporarily restricted. Please contact support.",
    "common.error_invalid_amount": "Enter a valid amount.",
    "common.error_invalid_method": "Choose an available method.",
    "common.error_invalid_details": "Check the payment details.",
    "common.error_invalid_bank": "Check the selected bank.",
    "common.error_small_payment_amount": "The amount is below the minimum for this method.",
    "common.error_unavailable_method": "This method is temporarily unavailable. Choose another one.",
    "common.error_currency_in_sale": "You cannot change currency while you have NFTs listed for sale. Remove them from sale and try again.",
    "common.error_invalid_code": "Invalid confirmation code. Check your app and try again.",
    "common.error_already_verified": "Email is already confirmed.",
    "common.error_unverified": "Email is not confirmed yet. Check your inbox and follow the link.",
    "common.error_unauthorized": "Your session is no longer valid. Please log in again.",
    "common.error_auction_not_found": "Auction not found.",
    "common.error_auction_not_started": "The auction hasn't started yet.",
    "common.error_auction_ended": "The auction has already ended.",
    "common.error_bid_too_low": "The bid is below the minimum. Refresh the page and raise your bid.",
    "common.error_buy_now_unavailable": "Buy now is not available for this lot.",
    "common.error_blocked_by_protection": "The request was blocked by protection. Turn off your proxy or VPN, or contact support.",
    "common.error_service_unavailable": "The service is temporarily unavailable. Please try again later.",
    "common.error_invalid_api_response": "The server returned data in an unsupported format.",
    "common.error_timeout": "The server didn't respond in time. Please try again.",
    "common.error_network": "Couldn't reach the server. Check your internet connection.",
    "common.error_aborted": "Request cancelled.",
    "common.error_rate_limited": "Too many requests. Please try again later.",
    "common.error_not_found": "The requested data was not found.",
    "common.error_conflict": "The data has changed. Refresh the page and try again.",
    "common.error_unprocessable": "Check the fields you filled in.",
    "common.error_request_failed": "The request failed. Please try again.",
    "common.error_unexpected": "An unexpected error occurred. Please try again."
  },
  ua: {
    "common.page_error_title": "Не вдалося відкрити сторінку",
    "common.page_error_description": "Оновіть сторінку. Якщо помилка повторюється, спробуйте пізніше.",
    "common.module_error_description": "Не вдалося завантажити файли сторінки. Перевірте підключення до інтернету й оновіть сторінку.",
    "common.reload_page": "Оновити сторінку",
    "common.loading": "Завантаження",
    "common.loading_page": "Завантажуємо сторінку",
    "common.loading_nfts": "Завантаження NFT",
    "common.load_failed": "Не вдалося завантажити дані",
    "common.retry": "Повторити",
    "common.close": "Закрити",
    "common.media_unavailable": "Зображення недоступне",
    "common.media_unavailable_alt": "{alt}: зображення недоступне",
    "common.brand_home": "{name} — головна",
    "common.support_contact": "Написати в підтримку",
    "common.restoring_session": "Відновлюємо сесію",
    "common.checking_session": "Перевіряємо сесію",
    "common.language": "Мова",

    "common.footer_nav": "Інформація",
    "common.footer_terms": "Умови використання",
    "common.footer_privacy": "Конфіденційність",
    "common.footer_support": "Підтримка",

    "common.cookie_region": "Використання cookie",
    "common.cookie_text": "Ми використовуємо cookie та локальне сховище для авторизації, мови й оформлення сайту. Кнопка «Зрозуміло» закриває це повідомлення.",
    "common.cookie_more": "Докладніше",
    "common.cookie_ok": "Зрозуміло",

    "common.not_found_title": "Сторінку не знайдено",
    "common.not_found_desc": "Перевірте адресу або виберіть доступний розділ.",
    "common.not_found_market": "До маркету",
    "common.not_found_home": "На головну",
    "common.not_found_owns": "Мої NFT",
    "common.not_found_login": "Увійти",

    "common.validation_email_required": "Вкажіть email.",
    "common.validation_email_invalid": "Введіть коректний email.",
    "common.validation_password_length": "Пароль має містити від 6 до 20 символів.",
    "common.validation_password_upper": "Додайте хоча б одну велику літеру.",
    "common.validation_password_lower": "Додайте хоча б одну малу літеру.",
    "common.validation_password_digit": "Додайте хоча б одну цифру.",
    "common.validation_password_special": "Додайте спеціальний символ: ! @ # $ % ^ & *.",
    "common.validation_invite_invalid": "Введіть коректний код запрошення.",

    "common.error_invalid_email": "Перевірте адресу електронної пошти.",
    "common.error_invalid_password": "Перевірте пароль.",
    "common.error_unknown_user": "Користувача з такими даними не знайдено.",
    "common.error_exists_email": "Ця адреса електронної пошти вже зареєстрована.",
    "common.error_invalid_invite_code": "Промокод не знайдено.",
    "common.error_not_have_money": "На балансі недостатньо коштів.",
    "common.error_already_owned": "Цей NFT уже належить вам.",
    "common.error_already_saled": "NFT уже виставлено на продаж.",
    "common.error_is_sold": "NFT уже продано.",
    "common.error_image_not_find": "NFT не знайдено.",
    "common.error_own_not_find": "NFT не знайдено серед ваших активів.",
    "common.error_u_cant_buy": "Покупки для акаунта тимчасово недоступні. Зверніться до підтримки.",
    "common.error_u_cant_withdraw": "Виведення тимчасово обмежено. Зверніться до підтримки.",
    "common.error_invalid_amount": "Введіть коректну суму.",
    "common.error_invalid_method": "Виберіть доступний метод.",
    "common.error_invalid_details": "Перевірте реквізити.",
    "common.error_invalid_bank": "Перевірте вибраний банк.",
    "common.error_small_payment_amount": "Сума менша за мінімальну для цього способу.",
    "common.error_unavailable_method": "Цей спосіб тимчасово недоступний. Виберіть інший.",
    "common.error_currency_in_sale": "Не можна змінити валюту, поки у вас є NFT, виставлені на продаж. Зніміть їх із продажу та спробуйте ще раз.",
    "common.error_invalid_code": "Невірний код підтвердження. Перевірте застосунок і спробуйте ще раз.",
    "common.error_already_verified": "Email уже підтверджено.",
    "common.error_unverified": "Email ще не підтверджено. Перевірте пошту й перейдіть за посиланням.",
    "common.error_unauthorized": "Сесія недійсна. Увійдіть знову.",
    "common.error_auction_not_found": "Аукціон не знайдено.",
    "common.error_auction_not_started": "Аукціон ще не розпочався.",
    "common.error_auction_ended": "Аукціон уже завершено.",
    "common.error_bid_too_low": "Ставка нижча за мінімальну. Оновіть сторінку й підвищте ставку.",
    "common.error_buy_now_unavailable": "Миттєвий викуп для цього лота недоступний.",
    "common.error_blocked_by_protection": "Запит заблоковано захистом. Вимкніть проксі або VPN чи зверніться до підтримки.",
    "common.error_service_unavailable": "Сервіс тимчасово недоступний. Спробуйте пізніше.",
    "common.error_invalid_api_response": "Сервер повернув дані в непідтримуваному форматі.",
    "common.error_timeout": "Сервер не відповів вчасно. Спробуйте ще раз.",
    "common.error_network": "Не вдалося зв'язатися із сервером. Перевірте підключення до інтернету.",
    "common.error_aborted": "Запит скасовано.",
    "common.error_rate_limited": "Забагато запитів. Спробуйте пізніше.",
    "common.error_not_found": "Запитувані дані не знайдено.",
    "common.error_conflict": "Дані вже змінилися. Оновіть сторінку й повторіть дію.",
    "common.error_unprocessable": "Перевірте заповнені поля.",
    "common.error_request_failed": "Не вдалося виконати запит. Спробуйте ще раз.",
    "common.error_unexpected": "Сталася непередбачена помилка. Спробуйте ще раз."
  },
  bl: {
    "common.page_error_title": "Не ўдалося адкрыць старонку",
    "common.page_error_description": "Абнавіце старонку. Калі памылка паўтараецца, паспрабуйце пазней.",
    "common.module_error_description": "Не ўдалося загрузіць файлы старонкі. Праверце падключэнне да інтэрнэту і абнавіце старонку.",
    "common.reload_page": "Абнавіць старонку",
    "common.loading": "Загрузка",
    "common.loading_page": "Загружаем старонку",
    "common.loading_nfts": "Загрузка NFT",
    "common.load_failed": "Не ўдалося загрузіць даныя",
    "common.retry": "Паўтарыць",
    "common.close": "Закрыць",
    "common.media_unavailable": "Выява недаступная",
    "common.media_unavailable_alt": "{alt}: выява недаступная",
    "common.brand_home": "{name} — галоўная",
    "common.support_contact": "Напісаць у падтрымку",
    "common.restoring_session": "Аднаўляем сесію",
    "common.checking_session": "Правяраем сесію",
    "common.language": "Мова",

    "common.footer_nav": "Інфармацыя",
    "common.footer_terms": "Умовы выкарыстання",
    "common.footer_privacy": "Канфідэнцыяльнасць",
    "common.footer_support": "Падтрымка",

    "common.cookie_region": "Выкарыстанне cookie",
    "common.cookie_text": "Мы выкарыстоўваем cookie і лакальнае сховішча для аўтарызацыі, мовы і афармлення сайта. Кнопка «Зразумела» закрывае гэта паведамленне.",
    "common.cookie_more": "Падрабязней",
    "common.cookie_ok": "Зразумела",

    "common.not_found_title": "Старонка не знойдзена",
    "common.not_found_desc": "Праверце адрас або выберыце даступны раздзел.",
    "common.not_found_market": "У маркет",
    "common.not_found_home": "На галоўную",
    "common.not_found_owns": "Мае NFT",
    "common.not_found_login": "Увайсці",

    "common.validation_email_required": "Укажыце email.",
    "common.validation_email_invalid": "Увядзіце карэктны email.",
    "common.validation_password_length": "Пароль павінен утрымліваць ад 6 да 20 сімвалаў.",
    "common.validation_password_upper": "Дадайце хаця б адну вялікую літару.",
    "common.validation_password_lower": "Дадайце хаця б адну малую літару.",
    "common.validation_password_digit": "Дадайце хаця б адну лічбу.",
    "common.validation_password_special": "Дадайце спецыяльны сімвал: ! @ # $ % ^ & *.",
    "common.validation_invite_invalid": "Увядзіце карэктны код запрашэння.",

    "common.error_invalid_email": "Праверце адрас электроннай пошты.",
    "common.error_invalid_password": "Праверце пароль.",
    "common.error_unknown_user": "Карыстальнік з такімі данымі не знойдзены.",
    "common.error_exists_email": "Гэты адрас электроннай пошты ўжо зарэгістраваны.",
    "common.error_invalid_invite_code": "Прамакод не знойдзены.",
    "common.error_not_have_money": "На балансе недастаткова сродкаў.",
    "common.error_already_owned": "Гэты NFT ужо належыць вам.",
    "common.error_already_saled": "NFT ужо выстаўлены на продаж.",
    "common.error_is_sold": "NFT ужо прададзены.",
    "common.error_image_not_find": "NFT не знойдзены.",
    "common.error_own_not_find": "NFT не знойдзены сярод вашых актываў.",
    "common.error_u_cant_buy": "Пакупкі для акаўнта часова недаступныя. Звярніцеся ў падтрымку.",
    "common.error_u_cant_withdraw": "Вывад часова абмежаваны. Звярніцеся ў падтрымку.",
    "common.error_invalid_amount": "Увядзіце карэктную суму.",
    "common.error_invalid_method": "Выберыце даступны метад.",
    "common.error_invalid_details": "Праверце рэквізіты.",
    "common.error_invalid_bank": "Праверце выбраны банк.",
    "common.error_small_payment_amount": "Сума меншая за мінімальную для гэтага спосабу.",
    "common.error_unavailable_method": "Гэты спосаб часова недаступны. Выберыце іншы.",
    "common.error_currency_in_sale": "Нельга змяніць валюту, пакуль у вас ёсць NFT, выстаўленыя на продаж. Зніміце іх з продажу і паспрабуйце яшчэ раз.",
    "common.error_invalid_code": "Няправільны код пацвярджэння. Праверце праграму і паспрабуйце зноў.",
    "common.error_already_verified": "Email ужо пацверджаны.",
    "common.error_unverified": "Email яшчэ не пацверджаны. Праверце пошту і перайдзіце па спасылцы.",
    "common.error_unauthorized": "Сесія несапраўдная. Увайдзіце зноў.",
    "common.error_auction_not_found": "Аўкцыён не знойдзены.",
    "common.error_auction_not_started": "Аўкцыён яшчэ не пачаўся.",
    "common.error_auction_ended": "Аўкцыён ужо завершаны.",
    "common.error_bid_too_low": "Стаўка ніжэйшая за мінімальную. Абнавіце старонку і павысьце стаўку.",
    "common.error_buy_now_unavailable": "Імгненны выкуп для гэтага лота недаступны.",
    "common.error_blocked_by_protection": "Запыт заблакаваны абаронай. Адключыце проксі або VPN ці звярніцеся ў падтрымку.",
    "common.error_service_unavailable": "Сэрвіс часова недаступны. Паспрабуйце пазней.",
    "common.error_invalid_api_response": "Сервер вярнуў даныя ў непадтрымліваемым фармаце.",
    "common.error_timeout": "Сервер не адказаў своечасова. Паспрабуйце яшчэ раз.",
    "common.error_network": "Не ўдалося звязацца з серверам. Праверце падключэнне да інтэрнэту.",
    "common.error_aborted": "Запыт адменены.",
    "common.error_rate_limited": "Занадта шмат запытаў. Паспрабуйце пазней.",
    "common.error_not_found": "Запытаныя даныя не знойдзены.",
    "common.error_conflict": "Даныя ўжо змяніліся. Абнавіце старонку і паўтарыце дзеянне.",
    "common.error_unprocessable": "Праверце запоўненыя палі.",
    "common.error_request_failed": "Не ўдалося выканаць запыт. Паспрабуйце яшчэ раз.",
    "common.error_unexpected": "Адбылася непрадбачаная памылка. Паспрабуйце яшчэ раз."
  },
  de: {
    "common.page_error_title": "Diese Seite konnte nicht geöffnet werden",
    "common.page_error_description": "Laden Sie die Seite neu. Falls das Problem weiterhin besteht, versuchen Sie es später erneut.",
    "common.module_error_description": "Die Dateien der Seite konnten nicht geladen werden. Prüfen Sie Ihre Internetverbindung und laden Sie die Seite neu.",
    "common.reload_page": "Seite neu laden",
    "common.loading": "Wird geladen",
    "common.loading_page": "Seite wird geladen",
    "common.loading_nfts": "NFTs werden geladen",
    "common.load_failed": "Daten konnten nicht geladen werden",
    "common.retry": "Erneut versuchen",
    "common.close": "Schließen",
    "common.media_unavailable": "Bild nicht verfügbar",
    "common.media_unavailable_alt": "{alt}: Bild nicht verfügbar",
    "common.brand_home": "{name} — Startseite",
    "common.support_contact": "Support kontaktieren",
    "common.restoring_session": "Sitzung wird wiederhergestellt",
    "common.checking_session": "Sitzung wird geprüft",
    "common.language": "Sprache",

    "common.footer_nav": "Informationen",
    "common.footer_terms": "Nutzungsbedingungen",
    "common.footer_privacy": "Datenschutz",
    "common.footer_support": "Support",

    "common.cookie_region": "Verwendung von Cookies",
    "common.cookie_text": "Wir verwenden Cookies und lokalen Speicher für Anmeldung, Sprache und Darstellung der Website. Die Schaltfläche „Verstanden“ schließt diesen Hinweis.",
    "common.cookie_more": "Mehr erfahren",
    "common.cookie_ok": "Verstanden",

    "common.not_found_title": "Seite nicht gefunden",
    "common.not_found_desc": "Prüfen Sie die Adresse oder wählen Sie einen verfügbaren Bereich.",
    "common.not_found_market": "Zum Markt",
    "common.not_found_home": "Zur Startseite",
    "common.not_found_owns": "Meine NFTs",
    "common.not_found_login": "Anmelden",

    "common.validation_email_required": "Geben Sie Ihre E-Mail-Adresse ein.",
    "common.validation_email_invalid": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "common.validation_password_length": "Das Passwort muss 6 bis 20 Zeichen lang sein.",
    "common.validation_password_upper": "Fügen Sie mindestens einen Großbuchstaben hinzu.",
    "common.validation_password_lower": "Fügen Sie mindestens einen Kleinbuchstaben hinzu.",
    "common.validation_password_digit": "Fügen Sie mindestens eine Ziffer hinzu.",
    "common.validation_password_special": "Fügen Sie ein Sonderzeichen hinzu: ! @ # $ % ^ & *.",
    "common.validation_invite_invalid": "Geben Sie einen gültigen Einladungscode ein.",

    "common.error_invalid_email": "Prüfen Sie Ihre E-Mail-Adresse.",
    "common.error_invalid_password": "Prüfen Sie Ihr Passwort.",
    "common.error_unknown_user": "Kein Benutzer mit diesen Daten gefunden.",
    "common.error_exists_email": "Diese E-Mail-Adresse ist bereits registriert.",
    "common.error_invalid_invite_code": "Promo-Code nicht gefunden.",
    "common.error_not_have_money": "Unzureichendes Guthaben.",
    "common.error_already_owned": "Dieses NFT gehört Ihnen bereits.",
    "common.error_already_saled": "Dieses NFT steht bereits zum Verkauf.",
    "common.error_is_sold": "Dieses NFT wurde bereits verkauft.",
    "common.error_image_not_find": "NFT nicht gefunden.",
    "common.error_own_not_find": "Dieses NFT wurde unter Ihren Assets nicht gefunden.",
    "common.error_u_cant_buy": "Käufe sind für dieses Konto vorübergehend nicht verfügbar. Wenden Sie sich an den Support.",
    "common.error_u_cant_withdraw": "Auszahlungen sind vorübergehend eingeschränkt. Wenden Sie sich an den Support.",
    "common.error_invalid_amount": "Geben Sie einen gültigen Betrag ein.",
    "common.error_invalid_method": "Wählen Sie eine verfügbare Methode.",
    "common.error_invalid_details": "Prüfen Sie die Zahlungsdaten.",
    "common.error_invalid_bank": "Prüfen Sie die ausgewählte Bank.",
    "common.error_small_payment_amount": "Der Betrag liegt unter dem Mindestbetrag für diese Methode.",
    "common.error_unavailable_method": "Diese Methode ist vorübergehend nicht verfügbar. Wählen Sie eine andere.",
    "common.error_currency_in_sale": "Sie können die Währung nicht ändern, solange Ihre NFTs zum Verkauf stehen. Entfernen Sie die Verkaufsangebote und versuchen Sie es erneut.",
    "common.error_invalid_code": "Ungültiger Bestätigungscode. Prüfen Sie die App und versuchen Sie es erneut.",
    "common.error_already_verified": "Die E-Mail-Adresse ist bereits bestätigt.",
    "common.error_unverified": "Die E-Mail-Adresse ist noch nicht bestätigt. Prüfen Sie Ihr Postfach und folgen Sie dem Link.",
    "common.error_unauthorized": "Die Sitzung ist ungültig. Melden Sie sich erneut an.",
    "common.error_auction_not_found": "Auktion nicht gefunden.",
    "common.error_auction_not_started": "Die Auktion hat noch nicht begonnen.",
    "common.error_auction_ended": "Die Auktion ist bereits beendet.",
    "common.error_bid_too_low": "Das Gebot liegt unter dem Mindestgebot. Laden Sie die Seite neu und erhöhen Sie Ihr Gebot.",
    "common.error_buy_now_unavailable": "Sofortkauf ist für dieses Los nicht verfügbar.",
    "common.error_blocked_by_protection": "Die Anfrage wurde vom Schutzsystem blockiert. Deaktivieren Sie Proxy oder VPN oder wenden Sie sich an den Support.",
    "common.error_service_unavailable": "Der Dienst ist vorübergehend nicht verfügbar. Versuchen Sie es später erneut.",
    "common.error_invalid_api_response": "Der Server hat Daten in einem nicht unterstützten Format geliefert.",
    "common.error_timeout": "Der Server hat nicht rechtzeitig geantwortet. Versuchen Sie es erneut.",
    "common.error_network": "Der Server ist nicht erreichbar. Prüfen Sie Ihre Internetverbindung.",
    "common.error_aborted": "Anfrage abgebrochen.",
    "common.error_rate_limited": "Zu viele Anfragen. Versuchen Sie es später erneut.",
    "common.error_not_found": "Die angeforderten Daten wurden nicht gefunden.",
    "common.error_conflict": "Die Daten haben sich geändert. Laden Sie die Seite neu und wiederholen Sie die Aktion.",
    "common.error_unprocessable": "Prüfen Sie die ausgefüllten Felder.",
    "common.error_request_failed": "Die Anfrage ist fehlgeschlagen. Versuchen Sie es erneut.",
    "common.error_unexpected": "Ein unerwarteter Fehler ist aufgetreten. Versuchen Sie es erneut."
  },
  fr: {
    "common.page_error_title": "Impossible d’ouvrir cette page",
    "common.page_error_description": "Rechargez la page. Si le problème persiste, réessayez plus tard.",
    "common.module_error_description": "Les fichiers de la page n’ont pas pu être chargés. Vérifiez votre connexion Internet et rechargez la page.",
    "common.reload_page": "Recharger la page",
    "common.loading": "Chargement",
    "common.loading_page": "Chargement de la page",
    "common.loading_nfts": "Chargement des NFT",
    "common.load_failed": "Impossible de charger les données",
    "common.retry": "Réessayer",
    "common.close": "Fermer",
    "common.media_unavailable": "Image indisponible",
    "common.media_unavailable_alt": "{alt} : image indisponible",
    "common.brand_home": "{name} — accueil",
    "common.support_contact": "Contacter le support",
    "common.restoring_session": "Restauration de la session",
    "common.checking_session": "Vérification de la session",
    "common.language": "Langue",

    "common.footer_nav": "Informations",
    "common.footer_terms": "Conditions d'utilisation",
    "common.footer_privacy": "Confidentialité",
    "common.footer_support": "Support",

    "common.cookie_region": "Utilisation des cookies",
    "common.cookie_text": "Nous utilisons des cookies et le stockage local pour la connexion, la langue et l'apparence du site. Le bouton « Compris » ferme cet avis.",
    "common.cookie_more": "En savoir plus",
    "common.cookie_ok": "Compris",

    "common.not_found_title": "Page introuvable",
    "common.not_found_desc": "Vérifiez l'adresse ou choisissez une section disponible.",
    "common.not_found_market": "Vers le marché",
    "common.not_found_home": "Vers l'accueil",
    "common.not_found_owns": "Mes NFT",
    "common.not_found_login": "Se connecter",

    "common.validation_email_required": "Saisissez votre e-mail.",
    "common.validation_email_invalid": "Saisissez un e-mail valide.",
    "common.validation_password_length": "Le mot de passe doit contenir de 6 à 20 caractères.",
    "common.validation_password_upper": "Ajoutez au moins une lettre majuscule.",
    "common.validation_password_lower": "Ajoutez au moins une lettre minuscule.",
    "common.validation_password_digit": "Ajoutez au moins un chiffre.",
    "common.validation_password_special": "Ajoutez un caractère spécial : ! @ # $ % ^ & *.",
    "common.validation_invite_invalid": "Saisissez un code d'invitation valide.",

    "common.error_invalid_email": "Vérifiez votre adresse e-mail.",
    "common.error_invalid_password": "Vérifiez votre mot de passe.",
    "common.error_unknown_user": "Aucun utilisateur trouvé avec ces informations.",
    "common.error_exists_email": "Cette adresse e-mail est déjà enregistrée.",
    "common.error_invalid_invite_code": "Code promo introuvable.",
    "common.error_not_have_money": "Solde insuffisant.",
    "common.error_already_owned": "Ce NFT vous appartient déjà.",
    "common.error_already_saled": "Ce NFT est déjà en vente.",
    "common.error_is_sold": "Ce NFT a déjà été vendu.",
    "common.error_image_not_find": "NFT introuvable.",
    "common.error_own_not_find": "Ce NFT est introuvable parmi vos actifs.",
    "common.error_u_cant_buy": "Les achats sont temporairement indisponibles pour ce compte. Contactez le support.",
    "common.error_u_cant_withdraw": "Les retraits sont temporairement limités. Contactez le support.",
    "common.error_invalid_amount": "Saisissez un montant valide.",
    "common.error_invalid_method": "Choisissez une méthode disponible.",
    "common.error_invalid_details": "Vérifiez les coordonnées de paiement.",
    "common.error_invalid_bank": "Vérifiez la banque sélectionnée.",
    "common.error_small_payment_amount": "Le montant est inférieur au minimum pour cette méthode.",
    "common.error_unavailable_method": "Cette méthode est temporairement indisponible. Choisissez-en une autre.",
    "common.error_currency_in_sale": "Vous ne pouvez pas changer de devise tant que vos NFT sont en vente. Retirez-les de la vente et réessayez.",
    "common.error_invalid_code": "Code de confirmation incorrect. Vérifiez l'application et réessayez.",
    "common.error_already_verified": "L'e-mail est déjà confirmé.",
    "common.error_unverified": "L'e-mail n'est pas encore confirmé. Consultez votre boîte de réception et suivez le lien.",
    "common.error_unauthorized": "La session n'est plus valide. Reconnectez-vous.",
    "common.error_auction_not_found": "Enchère introuvable.",
    "common.error_auction_not_started": "L'enchère n'a pas encore commencé.",
    "common.error_auction_ended": "L'enchère est déjà terminée.",
    "common.error_bid_too_low": "L'offre est inférieure au minimum. Actualisez la page et augmentez votre offre.",
    "common.error_buy_now_unavailable": "L'achat immédiat n'est pas disponible pour ce lot.",
    "common.error_blocked_by_protection": "La requête a été bloquée par la protection. Désactivez votre proxy ou VPN, ou contactez le support.",
    "common.error_service_unavailable": "Le service est temporairement indisponible. Réessayez plus tard.",
    "common.error_invalid_api_response": "Le serveur a renvoyé des données dans un format non pris en charge.",
    "common.error_timeout": "Le serveur n'a pas répondu à temps. Réessayez.",
    "common.error_network": "Impossible de joindre le serveur. Vérifiez votre connexion Internet.",
    "common.error_aborted": "Requête annulée.",
    "common.error_rate_limited": "Trop de requêtes. Réessayez plus tard.",
    "common.error_not_found": "Les données demandées sont introuvables.",
    "common.error_conflict": "Les données ont changé. Actualisez la page et recommencez.",
    "common.error_unprocessable": "Vérifiez les champs remplis.",
    "common.error_request_failed": "La requête a échoué. Réessayez.",
    "common.error_unexpected": "Une erreur inattendue s'est produite. Réessayez."
  },
  cn: {
    "common.page_error_title": "无法打开此页面",
    "common.page_error_description": "请刷新页面。如果问题仍然存在，请稍后重试。",
    "common.module_error_description": "无法加载页面文件。请检查网络连接并刷新页面。",
    "common.reload_page": "刷新页面",
    "common.loading": "加载中",
    "common.loading_page": "正在加载页面",
    "common.loading_nfts": "正在加载NFT",
    "common.load_failed": "无法加载数据",
    "common.retry": "重试",
    "common.close": "关闭",
    "common.media_unavailable": "图片不可用",
    "common.media_unavailable_alt": "{alt}：图片不可用",
    "common.brand_home": "{name} — 首页",
    "common.support_contact": "联系客服",
    "common.restoring_session": "正在恢复会话",
    "common.checking_session": "正在检查会话",
    "common.language": "语言",

    "common.footer_nav": "信息",
    "common.footer_terms": "使用条款",
    "common.footer_privacy": "隐私政策",
    "common.footer_support": "客服支持",

    "common.cookie_region": "Cookie 使用",
    "common.cookie_text": "我们使用 Cookie 和本地存储来实现登录、语言和网站外观设置。点击“知道了”即可关闭此提示。",
    "common.cookie_more": "了解更多",
    "common.cookie_ok": "知道了",

    "common.not_found_title": "页面未找到",
    "common.not_found_desc": "请检查地址或选择可用的板块。",
    "common.not_found_market": "前往市场",
    "common.not_found_home": "返回首页",
    "common.not_found_owns": "我的NFT",
    "common.not_found_login": "登录",

    "common.validation_email_required": "请输入邮箱。",
    "common.validation_email_invalid": "请输入有效的邮箱。",
    "common.validation_password_length": "密码长度须为 6 至 20 个字符。",
    "common.validation_password_upper": "请至少添加一个大写字母。",
    "common.validation_password_lower": "请至少添加一个小写字母。",
    "common.validation_password_digit": "请至少添加一个数字。",
    "common.validation_password_special": "请添加一个特殊字符：! @ # $ % ^ & *。",
    "common.validation_invite_invalid": "请输入有效的邀请码。",

    "common.error_invalid_email": "请检查邮箱地址。",
    "common.error_invalid_password": "请检查密码。",
    "common.error_unknown_user": "未找到该用户。",
    "common.error_exists_email": "该邮箱地址已被注册。",
    "common.error_invalid_invite_code": "未找到该优惠码。",
    "common.error_not_have_money": "余额不足。",
    "common.error_already_owned": "您已拥有此NFT。",
    "common.error_already_saled": "此NFT已在出售中。",
    "common.error_is_sold": "此NFT已售出。",
    "common.error_image_not_find": "未找到NFT。",
    "common.error_own_not_find": "在您的资产中未找到此NFT。",
    "common.error_u_cant_buy": "该账户暂时无法购买，请联系客服。",
    "common.error_u_cant_withdraw": "提现暂时受限，请联系客服。",
    "common.error_invalid_amount": "请输入有效金额。",
    "common.error_invalid_method": "请选择可用的方式。",
    "common.error_invalid_details": "请检查收款信息。",
    "common.error_invalid_bank": "请检查所选银行。",
    "common.error_small_payment_amount": "金额低于该方式的最低限额。",
    "common.error_unavailable_method": "该方式暂时不可用，请选择其他方式。",
    "common.error_currency_in_sale": "您有正在出售的 NFT，暂时无法更改货币。请先下架这些 NFT，然后重试。",
    "common.error_invalid_code": "验证码错误。请检查验证器应用后重试。",
    "common.error_already_verified": "邮箱已验证。",
    "common.error_unverified": "邮箱尚未验证。请查收邮件并点击链接。",
    "common.error_unauthorized": "会话已失效，请重新登录。",
    "common.error_auction_not_found": "未找到拍卖。",
    "common.error_auction_not_started": "拍卖尚未开始。",
    "common.error_auction_ended": "拍卖已结束。",
    "common.error_bid_too_low": "出价低于最低价。请刷新页面并提高出价。",
    "common.error_buy_now_unavailable": "该拍品不支持一口价购买。",
    "common.error_blocked_by_protection": "请求被安全防护拦截。请关闭代理或 VPN，或联系客服。",
    "common.error_service_unavailable": "服务暂时不可用，请稍后再试。",
    "common.error_invalid_api_response": "服务器返回了不支持的数据格式。",
    "common.error_timeout": "服务器未及时响应，请重试。",
    "common.error_network": "无法连接服务器，请检查网络连接。",
    "common.error_aborted": "请求已取消。",
    "common.error_rate_limited": "请求过于频繁，请稍后再试。",
    "common.error_not_found": "未找到请求的数据。",
    "common.error_conflict": "数据已更改。请刷新页面后重试。",
    "common.error_unprocessable": "请检查已填写的字段。",
    "common.error_request_failed": "请求失败，请重试。",
    "common.error_unexpected": "发生意外错误，请重试。"
  }
});
